import { Injectable } from '@angular/core';
import { StartupModel, ImageUploadUrl, StateModel, IndustryModel, SectorModel } from '../classes/model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

const httpOptions1 = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }), responseType: 'text' as 'json'
};

@Injectable()
export class RdsServerService {

  constructor(private http: HttpClient) { }

  _url = 'https://ebnro45a9h.execute-api.ap-south-1.amazonaws.com/v2';
  // _url = 'http://localhost:3000';

  //  ===============  POST STARTUP FORM  ====================
  postStartupForm(databody: StartupModel): Observable<StartupModel> {
    return this.http.post<StartupModel>(this._url + '/postMeityStartup', databody, httpOptions1);
  }
  // ===============  SECTOR LOGO IMAGE UPLOAD  ====================
  getStartupLogoImageUrl(imageKey, extension): Observable<ImageUploadUrl> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<ImageUploadUrl>(this._url + '/getStartupLogos' + '?ImageKey=' + imageKey + '&extension=' + extension, httpOptions);
  }
  // ===============  SECTOR PITCH IMAGE UPLOAD  ====================
  getStartupPitchImageUrl(imageKey, extension): Observable<ImageUploadUrl> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<ImageUploadUrl>(this._url + '/getStartupPitch' + '?ImageKey=' + imageKey + '&extension=' + extension, httpOptions);
  }

  getStateList(): Observable<StateModel> {
    return this.http.get<StateModel>(this._url + '/getStates');
  }

  getCityList(id): Observable<StateModel> {
    return this.http.get<StateModel>(this._url + '/getCities?id=' + id);
  }

  getIndustryList(): Observable<IndustryModel> {
    return this.http.get<IndustryModel>(this._url + '/getIndustry');
  }

  getSectorList(id): Observable<SectorModel> {
    return this.http.get<SectorModel>(this._url + '/getSectorList?id=' + id);
  }

  getAllSectorList(): Observable<SectorModel> {
    return this.http.get<SectorModel>(this._url + '/getAllSectorList');
  }


  getFileUploadLink(filename, folder, ext) {
    return this.http.get('https://4xikfzks63.execute-api.ap-south-1.amazonaws.com/alpha' + `/getFileUploadLink?fileKey=${filename}&folder=${folder}&ext=${ext}`);
  }

  uploadImage(imageUploadUrl: string, extension: any, key: any, file: any): Observable<Object> {

    var images = ['.png', '.jpg', '.jpeg']
    var ctype;
    if (images.indexOf(extension) != -1)
      ctype = 'image/' + extension
    else if (extension == 'pdf')
      ctype = 'application/pdf'
    else
      ctype = ''

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': ctype
        })
    };
    return this.http.put(imageUploadUrl, file, httpOptions);
  }

  /**
     * Global Function to get s3 link and upload file in it
     * @param keyname KeyName to upload with
     * @param folder S3 bucket to upload in
     * @param blob File Blob
     * @param extension File Extension
     * @returns Promise
     */
  getLinkAndUpload(keyname, folder, blob, extension) {
    return new Promise((resolve, reject) => {
      this.getFileUploadLink(keyname, folder, extension).subscribe(res => {
        this.uploadImage(res['fileUrl'], extension, '', blob).subscribe(prog => {
          resolve({ status: true, meta: [res['fileUrl'], prog] })
        }, err => reject({ status: false }))
      }, errr => reject({ status: false }))
    })
  }

}
